module.exports = __webpack_public_path__ + "img/label_miaosha@3x.3f0af5c1.png";